import React from 'react';
import Table from 'react-bootstrap/Table';
import { ICronJob } from '../../models/ICronJob';
import CronJobsListItem from './CronJobsListItem';

type CronJobsListProps = {
    cronJobs: ICronJob[];
}

const CronJobsList: React.FC<CronJobsListProps> = ({ cronJobs }) => {
    return (
        <Table striped bordered hover>
            <thead>
                <tr>
                    <th>Title</th>
                    <th>Alias</th>
                    <th>Status</th>
                    <th>Created at</th>
                </tr>
            </thead>
            <tbody>
                {cronJobs.map(cronJob => <CronJobsListItem key={cronJob.id} cronJob={cronJob} />)}
            </tbody>
        </Table>
    );
};

export default CronJobsList;
